'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fab';
var iconName = 'gayl';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = '';
var svgPathData = 'M428.4,115.7c-65.4-3.1-91.6,44.6-100.6,67.8C206.2-57.2-216.1,152.5,161.7,321c74.8,33.3,109.6,78.7,127,114.1,c3.1,4.6,8.4,0.8,8.7-0.2c11.9-19.8,27.4-37.7,45.5-52.7c41.9-33.9,108.3-79.7,141.5-125.8C517.7,209.9,514.4,119.8,428.4,115.7';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faGayl = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;